// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3l-1";
export var movingGradient = "_3l-4";
export var movingGradientBlock = "_3l-2";
export var skeleton = "_3l-0";
export var skeletonText = "_3l-3";